document.addEventListener('DOMContentLoaded', () => {
  // 商品ページ以外では何もしない
  if (!document.body.classList.contains('template-product')) return;

  // すでにモーダルがあれば二重生成しない
  if (document.querySelector('.image-modal')) return;

  // モーダル作成
  const modal = document.createElement('div');
  modal.className = 'image-modal is-hidden';
  modal.innerHTML = '<img src="" alt="">';
  document.body.appendChild(modal);

  const modalImg = modal.querySelector('img');
  const FADE_MS = 350; // CSSのtransitionと同じ

  const openModal = (src, altText = '') => {
    modalImg.src = src;
    modalImg.alt = altText;

    modal.classList.remove('is-hidden');
    requestAnimationFrame(() => {
      modal.classList.add('is-active');
    });
  };

  const closeModal = () => {
    modal.classList.remove('is-active');
    setTimeout(() => {
      modal.classList.add('is-hidden');
      modalImg.src = '';
    }, FADE_MS);
  };

  // ✅ 重要：テーマ側より先にクリックを奪う（capture=true）
  document.addEventListener(
    'click',
    (e) => {
      // 商品画像エリアの img をクリックした時だけ反応
      const img = e.target && e.target.closest ? e.target.closest('.product__media img') : null;
      if (!img) return;

      // テーマ側のズーム/ギャラリー/スライダークリックを止める
      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();

      const src = img.currentSrc || img.src;
      const alt = img.getAttribute('alt') || '';

      openModal(src, alt);
    },
    true // ← capture（ここが肝）
  );

  // 背景クリックで閉じる（画像自体は閉じない）
  modal.addEventListener('click', (e) => {
    if (e.target === modalImg) return;
    closeModal();
  });

  // ESCで閉じる
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !modal.classList.contains('is-hidden')) {
      closeModal();
    }
  });
});

